export async function createPageViewRequest(eventData) {
    const {
        eventName = '',
        origin,
        instanceId,
        pageId,
        statePage,
        currentUrl,
        parent = '',
    } = eventData;
    const destinationUrl = window.location.origin || window.location.host;
    const joinedEventName = (parent ? `${parent}-${eventName}` : eventName).replace(/\s+/g, '-').toLowerCase();

    const cdpparams = [
        ['type=event'],
        [`event_name=${joinedEventName}`],
        [`origin=${origin}`],
        [`origin_url=${encodeURIComponent(destinationUrl)}`],
        [`referral_url=${encodeURIComponent(currentUrl)}`],
        [`instance_id=${instanceId}`],
        [`page_id=${pageId}`],
        [`page_name=${statePage}`],
    ];

    const cdpTrackingRequestUrl = `${destinationUrl}/_i?${cdpparams.join('&')}`;

    fetch(cdpTrackingRequestUrl, {
        method: 'GET',
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
        })
        .catch(error => {
            console.error('Tracking error:', error);
        });
}
